import { Logout, Notification, NotificationNew, User } from "@carbon/icons-react";
import { HeaderGlobalAction, HeaderGlobalBar } from '@carbon/react';
import { useSelector } from "react-redux";
import { selectNotifications, selectNavigationIcons } from "../../../features/application/applicationSlice.js";
import LanguageSelector from "../LanguageSelector";
import { useTranslation } from "react-i18next";

const HeaderGlobal = ({ onProfileClick, onNotificationsClick, onLogoutClick }) => {
    const { t } = useTranslation();
    const notifications = useSelector(selectNotifications);
    const { profile: navProfile, notifications: navNotifications } = useSelector(selectNavigationIcons);

    return (
        <HeaderGlobalBar className="mm-header-global">
            <LanguageSelector />
            {navProfile.active && (
                <HeaderGlobalAction aria-label={t("header.profileAction")}
                    onClick={() => onProfileClick(navProfile)}><User />
                </HeaderGlobalAction>
            )}
            {navNotifications.active && (
                <HeaderGlobalAction aria-label={t("header.notificationsAction")}
                    onClick={() => onNotificationsClick(navNotifications)}>
                    {notifications.length > 0 &&
                        <NotificationNew />}
                    {notifications.length === 0 &&
                        <Notification />}
                </HeaderGlobalAction>
            )}
            <HeaderGlobalAction aria-label={t("header.logoutAction")}
                onClick={onLogoutClick}><Logout />
            </HeaderGlobalAction>
        </HeaderGlobalBar>
    );
};

export default HeaderGlobal;
